import "./App.css";
import Sidebar from "./components/Sidebar";
import Home from "./pages/Dashboard/Dashboard";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import { ThemeProvider } from "./providers/ThemeProvider";
import { useAuthContext } from "./hooks/useAuthContext";
import Loading from "./components/Loading";
import Profile from "./pages/Profile/Profile";
import { useEffect, useRef, useState } from "react";
import { Toaster } from "@/shadcn/components/ui/toaster";
import { UserDocProvider } from "./contexts/UserDocContext";
import useMediaQuery from "./hooks/useMediaQuery";
import Topbar from "./components/Topbar";
import PasswordRecovery from "./pages/Recover/Recover";
import Help from "./pages/Help/Help";
import Training from "./pages/Training/Training";
import Refer from "./pages/Refer/Refer";
import { ReferrerDocProvider } from "./contexts/ReferrerDocContext";
import { db } from "./firebase/config";
import { doc, onSnapshot } from "firebase/firestore";
import Onboarding from "./pages/Onboarding/Onboarding";
import Admin from "./pages/Admin/Admin";
import AdminPanel from "./pages/AdminPanel/AdminPanel";
import DuePayment from "./pages/AdminPanel/DuePayment";
import Refer2 from "./pages/Refer/Refer2";
import Dashboard from "./pages/Dashboard/Dashboard";
import TopbarMobile from "./components/TopbarMobile";
import BottomBar from "./components/BottomBar";
import Maia from "./pages/Maia/Maia";
import ManageComments from "./pages/Admin/ManageComments";

function AppRoutes() {
  const { user, authIsReady } = useAuthContext();
  const [rerender, setRerender] = useState(false);
  const [onboarding, setOnboarding] = useState(null);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [isWatching, setIsWatching] = useState(false);
  const [redirectToRoute, setRedirectToRoute] = useState(null);
  const [userDoc, setUserDoc] = useState(null);
  const [error, setError] = useState(null);
  const isMobile = useMediaQuery("(max-width: 640px)");
  const scrollToTop = useRef(null);
  const [activeRoute, setActiveRoute] = useState(0);

  // useEffect(() => {
  //   let unsub = () => {};

  //   const checkOnboarding = () => {
  //     unsub = onSnapshot(
  //       doc(db, "users", user.uid),
  //       (docSnapshot) => {
  //         if (docSnapshot.exists()) {
  //           const userData = { ...docSnapshot.data(), id: docSnapshot.id };
  //           setUserDoc(userData);
  //           setError(null);
  //           setOnboarding(userData.onboarding || 0);
  //           setRedirectToRoute(
  //             userData.redirectToRoute || { active: false, path: null }
  //           );
  //         } else {
  //           setError("Dados não encontrados.");
  //           setUserDoc(undefined);
  //           setOnboarding(0);
  //           setRedirectToRoute({ active: false, path: null });
  //           console.log(
  //             `Dados não encontrados. Collection: users, ID: ${user.uid}`
  //           );
  //         }
  //       },
  //       (err) => {
  //         console.log(err);
  //         setError(err.message);
  //         setUserDoc(undefined);
  //         setOnboarding(0);
  //         setRedirectToRoute({ active: false, path: null });
  //         console.log(
  //           "Erro ao ler documento da coleção:",
  //           "users",
  //           "com ID:",
  //           user.uid
  //         );
  //       }
  //     );
  //   };

  //   if (authIsReady && user) {
  //     checkOnboarding();
  //   }

  //   return () => unsub();
  // }, [authIsReady, user]);

  if (!authIsReady) {
    console.log("Not auth is ready");
    return <Loading />;
  }

  // if (user && (onboarding === null || userDoc === null)) {
  //   console.log("user && (onboarding === null || !userDoc)");
  //   return <Loading />;
  // }

  // if (user && onboarding > -1 && userDoc.new) {
  //   return (
  //     <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
  //       <div className="App flex flex-col sm:flex-row">
  //         <BrowserRouter>
  //           <Routes>
  //             <Route
  //               path="*"
  //               element={
  //                 <Onboarding userDoc={userDoc} onboarding={onboarding} />
  //               }
  //             />
  //           </Routes>
  //         </BrowserRouter>
  //       </div>
  //     </ThemeProvider>
  //   );
  // }

  // if (user && redirectToRoute.active) {
  //   return (
  //     <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
  //       <div className="App flex flex-col sm:flex-row">
  //         <BrowserRouter>
  //           <Routes>
  //             <Route
  //               path="*"
  //               element={<Training redirectToRoute={redirectToRoute} />}
  //             />
  //           </Routes>
  //         </BrowserRouter>
  //       </div>
  //     </ThemeProvider>
  //   );
  // }

  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <div
        ref={scrollToTop}
        className="App flex flex-col sm:flex-row bg-background "
      >
        <Toaster />
        <BrowserRouter>
          {user ? (
            <UserDocProvider user={user}>
              <ReferrerDocProvider user={user}>
                {isMobile ? (
                  <TopbarMobile setRerender={setRerender} />
                ) : (
                  <Topbar setRerender={setRerender} />
                )}
                {isMobile ? null : (
                  <div
                    className={`${
                      sidebarExpanded ? "w-[284px]" : "w-[90px]"
                    } w-[286px] h-[calc(100vh_-_120px)] fixed top-24 left-5 bottom-5 overflow-y-hidden border rounded-md`}
                  >
                    <Sidebar
                      rerender={rerender}
                      setRerender={setRerender}
                      sidebarExpanded={sidebarExpanded}
                      setSidebarExpanded={setSidebarExpanded}
                      isWatching={isWatching}
                      setIsWatching={setIsWatching}
                      activeRoute={activeRoute}
                      setActiveRoute={setActiveRoute}
                    />
                  </div>
                )}
                <div
                  className={`${
                    sidebarExpanded && !isWatching
                      ? "sm:w-[calc(100%_-_300px)] sm:ml-[310px]"
                      : "sm:w-[calc(100%_-_40px)] sm:ml-[112px]"
                  } mt-[80px] px-2.5 sm:px-5 sm:mt-[112px]`}
                >
                  <Routes>
                    <Route
                      exact
                      path="/"
                      element={
                        <Dashboard
                          sidebarExpanded={sidebarExpanded}
                          setSidebarExpanded={setSidebarExpanded}
                          isWatching={isWatching}
                          setIsWatching={setIsWatching}
                          activeRoute={activeRoute}
                          setActiveRoute={setActiveRoute}
                        />
                      }
                    />
                    <Route path="/maia" element={<Maia />} />
                    {user.uid === "fkwBohK4VsbkCGWcAqZ2EQ2uz9M2" && (
                      <Route
                        path="/admin/comments"
                        element={<ManageComments />}
                      />
                    )}
                    {user.uid === "fkwBohK4VsbkCGWcAqZ2EQ2uz9M2" && (
                      <Route path="/admin" element={<Admin />} />
                    )}
                    <Route
                      path="/assistir"
                      element={
                        <Training
                          scrollToTop={scrollToTop}
                          sidebarExpanded={sidebarExpanded}
                          setSidebarExpanded={setSidebarExpanded}
                          isWatching={isWatching}
                          setIsWatching={setIsWatching}
                        />
                      }
                    />
                    <Route
                      path="/entrenamiento"
                      element={
                        <Training
                          sidebarExpanded={sidebarExpanded}
                          setSidebarExpanded={setSidebarExpanded}
                          isWatching={isWatching}
                          setIsWatching={setIsWatching}
                        />
                      }
                    />
                    <Route path="/indique" element={<Refer2 />} />
                    {/* <Route path="/indique2" element={<Refer2 />} /> */}
                    <Route
                      path="/conta"
                      element={
                        <Profile
                          rerender={rerender}
                          setRerender={setRerender}
                        />
                      }
                    />
                    <Route
                      path="/perfil"
                      element={
                        <Onboarding userDoc={userDoc} onboarding={onboarding} />
                      }
                    />
                    <Route path="/help" element={<Help />} />
                    <Route
                      path="*"
                      element={
                        <Dashboard
                          sidebarExpanded={sidebarExpanded}
                          setSidebarExpanded={setSidebarExpanded}
                          isWatching={isWatching}
                          setIsWatching={setIsWatching}
                        />
                      }
                    />
                  </Routes>
                </div>
                {isMobile ? (
                  <div className="h-16 fixed bottom-0 left-0">
                    <BottomBar />
                  </div>
                ) : null}
              </ReferrerDocProvider>
            </UserDocProvider>
          ) : (
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/password/recovery" element={<PasswordRecovery />} />
              <Route path="*" element={<Login />} />
            </Routes>
          )}
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default AppRoutes;
